import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var CancelOrderIA = function CancelOrderIA(_ref) {
  var _context$brandOrder, _context$brandOrder$b;
  var context = _ref.context;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4agNLN",
    defaultMessage: [{
      "type": 0,
      "value": "Bestellingen kunnen onder specifieke omstandigheden worden geannuleerd voordat ze bepaalde verwerkingsfasen bereiken. Meer informatie over waarom een specifieke bestelling is geannuleerd kan je vinden op de tijdlijn voor die bestelling op de "
    }, {
      "children": [{
        "type": 0,
        "value": "bestellingspagina"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": ". Hier is een overzicht van wanneer bestellingen kunnen worden geannuleerd."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return OrderLinkFormatting(chunks, brandOrderToken);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "8z47MZ",
    defaultMessage: [{
      "type": 0,
      "value": "Ten eerste kun je nog niet verwerkte bestellingen annuleren als je ze om specifieke redenen niet kunt verwerken, zoals bij voorraadproblemen of exclusiviteitsconflicten."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return OrderLinkFormatting(chunks, brandOrderToken);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4ZAq1R",
    defaultMessage: [{
      "type": 0,
      "value": "Retailers kunnen een bestelling binnen de 24 uur annuleren, zolang de bestelling nog niet is geaccepteerd. Na deze periode of nadat je een bestelling hebt geaccepteerd, krijg je een annuleringsverzoek en kun je het verzoek accepteren of weigeren."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "7c/yYT",
    defaultMessage: [{
      "type": 0,
      "value": "Ten slotte kunnen bestellingen automatisch door Faire worden geannuleerd wanneer het verwerken van de bestelling erg veel vertraging oploopt. Dit kan voor nieuwe bestellingen voorvallen als je binnen 30 dagen geen verwachte verzenddatum invoert of voor geaccepteerde bestellingen wanneer je binnen 30 dagen na de opgegeven verzenddatum geen trackinggegevens verstrekt."
    }]
  })));
};
var OrderLinkFormatting = function OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrders(),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};